import { app } from '../../bootstrap/core';
import { oldPortfolioState } from './oldPortfolio.state';
import { oldPortfolioComponent } from './oldPortfolio.component';

app.config(oldPortfolioState);
app.component(oldPortfolioComponent.name, oldPortfolioComponent);



// WEBPACK FOOTER //
// ./src/app/components/oldPortfolio/oldPortfolio.js